import { render } from "./Strength.vue?vue&type=template&id=4a90acf8"
import script from "./Strength.vue?vue&type=script&lang=js"
export * from "./Strength.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/Work/CIS_HOME/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__